import { ConfirmModal } from '@components/atomic/organisms';
import { IcoUploadDocument } from '@icons';
import React from 'react';
import { Button } from 'react-bootstrap';
import MassiveSalUploadModal from './MassiveSalUploadModal';
import Banner from '@components/atomic/atoms/Banner/Banner';

interface MassiveSalUploadProps {}

const MassiveSalUpload: React.FC<MassiveSalUploadProps> = () => {
	const [isConfirmModalOpen, setIsConfirmModalOpen] = React.useState(false);
	const [isUploadModalOpen, setIsUploadModalOpen] = React.useState(false);
	return (
		<>
			<Button
				style={{
					height: '39px',
					display: 'flex',
					alignItems: 'center',
					gap: '0.5rem',
				}}
				onClick={() => {
					setIsConfirmModalOpen(true);
				}}
			>
				<IcoUploadDocument
					style={{
						width: '24px',
						height: '24px',
					}}
				/>
				Carica rendiconto
			</Button>
			<ConfirmModal
				size="lg"
				show={isConfirmModalOpen}
				onHide={() => {
					setIsConfirmModalOpen(false);
				}}
				title="Attenzione"
				callback={() => {
					setIsConfirmModalOpen(false);
					setIsUploadModalOpen(true);
				}}
				confirmButtonLabel="procedi"
				message={
					<div style={{ textAlign: 'left', display: 'grid', gap: '1rem' }}>
						<div>
							Il template consente il caricamento esclusivo di voci <b>eleggibili</b> ai fini della rendicontazione.
						</div>

						<Banner
							variant="warning"
							message={
								<>
									Le fatture che non rispettano i criteri di eleggibilità previsti (es. periodo di competenza, tipologia di spesa, stato
									della fattura) <b>non verranno importate</b>. Ti consigliamo di verificare la correttezza dei dati prima di procedere con
									il caricamento.
								</>
							}
						/>
						<div>
							Puoi caricare i template per i <b>Costi Esterni</b>, i <b>Costi Interni</b> o entrambi - dipende da quali tipologie di spesa
							vuoi rendicontare in questa bozza.
						</div>

						<Banner
							variant="danger"
							message={
								<>
									<b>Importante:</b> durante l'intera operazione di importazione massiva, assicurati che nessun altro utente aggiunga
									manualmente - tramite la UI della piattaforma - le stesse fatture o voci di costo che stai gestendo con questo
									caricamento. Operazioni simultanee sulle stesse voci potrebbero causare inconsistenze nella bozza.
								</>
							}
						/>
					</div>
				}
			/>
			<MassiveSalUploadModal isModalOpen={isUploadModalOpen} setIsModalOpen={setIsUploadModalOpen} />
		</>
	);
};

export default MassiveSalUpload;
